<script setup>
import { computed, onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import { useLanguageStore } from "@/stores/languageStore.js";
import { useSkinStore } from "@/stores/skinStore.js";
import { SKIN_DATA } from "@/game/runtime/ui/skinView.js";
import { getSkinName } from "@/i18n/messages.js";
import SkinPreview from "@/components/SkinPreview.vue";

const router = useRouter();
const languageStore = useLanguageStore();
const skinStore = useSkinStore();
const category = ref("ball");

const skins = computed(() => SKIN_DATA[category.value] || []);

function displayName(skin) {
  return getSkinName(skin.id, languageStore.language);
}

onMounted(async () => {
  try {
    await skinStore.refresh();
  } catch (error) {
    console.warn(
      "Backend skin sync failed.",
      error
    );
  }
});
</script>

<template>
  <section class="skins page-card">
    <div class="page-header">
      <button class="back-button" @click="router.push({ name: 'home' })">← {{ languageStore.t('back') }}</button>
      <h1 class="page-title">{{ languageStore.t('skinsTitle') }}</h1>
      <span />
    </div>

    <div class="skin-tabs">
      <button class="choice" :class="{ active: category === 'ball' }" @click="category = 'ball'">{{ languageStore.t('ballSkins') }}</button>
      <button class="choice" :class="{ active: category === 'paddle' }" @click="category = 'paddle'">{{ languageStore.t('paddleSkins') }}</button>
    </div>

    <div class="skin-grid">
      <button
        v-for="skin in skins"
        :key="skin.id"
        class="skin-card"
        :class="{ active: skinStore.selection[category] === skin.id }"
        @click="skinStore.select(category, skin.id)"
      >
        <SkinPreview :category="category" :type="skin.type || 'default'" />
        <strong>{{ displayName(skin) }}</strong>
        <small v-if="skinStore.selection[category] === skin.id">✓ {{ languageStore.t('selected') }}</small>
      </button>
    </div>

  </section>
</template>

<style scoped>
.skins { padding: 22px; }
.skin-tabs { display: flex; gap: 8px; margin-bottom: 16px; }
.choice { flex: 1; border: 1px solid rgba(82,246,232,.24); border-radius: 12px; padding: 11px; color: #fff; background: rgba(5,31,49,.72); }
.choice.active { border-color: #52f6e8; background: rgba(24,109,119,.68); }
.skin-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(135px, 1fr)); gap: 12px; }
.skin-card { min-height: 158px; display: grid; place-items: center; align-content: center; gap: 8px; border: 1px solid rgba(82,246,232,.18); border-radius: 16px; color: #fff; background: rgba(5,30,47,.74); }
.skin-card.active { border-color: #52f6e8; box-shadow: 0 0 20px rgba(82,246,232,.12); }
.skin-card small { color: #52f6e8; }
</style>
